import * as rdd from 'react-device-detect';

const devices = {
  isMobile: rdd.isMobileOnly,
  isTablet: rdd.isTablet,
  isSmartTV: rdd.isSmartTV,
  isDesktop: rdd.isDesktop,
  defaultDevice: rdd.deviceType,
};

export const MOBILE_KEY = 'MOVIL';
export const PC_KEY = 'PC';
const TABLET_KEY = 'TABLET';
const SMARTTV_KEY = 'SMARTTV';
export const getDeviceKey = () => {
  if (devices.isDesktop) {
    return PC_KEY;
  }
  if (devices.isTablet) {
    return TABLET_KEY;
  }
  if (devices.isMobile) {
    return MOBILE_KEY;
  }
  if (devices.isSmartTV) {
    return SMARTTV_KEY;
  }

  return devices.defaultDevice.toUpperCase();
};

export const getAppKey = () => {
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return 'PWA';
  }

  return 'WEB';
};
